// Copyright (c) Konnecta Systems. All rights reserved.
// Licensed under the Custom License. See LICENSE file in the project root for full license information.
// This was autogenerated by zAppDev.
import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class ReportingPeriod  {
    _originalTypeClassName = "Loom.BO.ReportingPeriod";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
ReportingPeriod.translate = translateService;
}
this.Id = null;
this.StartDate = null;
this.EndDate = null;
this.PeriodIndex = null;
this.Title = null;
this.Informal = false;
this.PeriodicReportDueDate = null;
this.StartMonth = null;
this.EndMonth = null;
this.Duration = null;
this._key = this.Id = 0; 
}

static translate: TranslateService;
_key: any;
private _Id:any;
get Id(): any {
    return this._Id;
  }
set Id(value: any) {
    this._Id = value;
    this._key = value;
  }
StartDate:any;
EndDate:any;
PeriodIndex:any;
Title:any;
Informal:any;
PeriodicReportDueDate:any;
StartMonth:any;
EndMonth:any;
Duration:any;
Project:any;
static setProject = ($this, value) => {
var oldValue = $this.Project;
$this.Project = value;
if (value != null) {
if (oldValue != null) {
Domain.Project.removeReportingPeriods(oldValue, $this);
}
Domain.Project.addReportingPeriods(value, $this);
}
}

static GetAcronym($this: any): any{return CLMS.Framework.String.Format("{0}P{1}", ($this?.Informal ? "I" : "R"), $this?.PeriodIndex);
}
static GetDuration($this: any): any{return Joove.Common.safeNumber($this?.EndMonth) - Joove.Common.safeNumber($this?.StartMonth) + Joove.Common.safeNumber(1);
}
static GetTitle($this: any): any{return CLMS.Framework.String.Format("{3}P{0} ({1} - {2})", $this?.PeriodIndex, CLMS.Framework.DateTime.ToString($this?.StartDate, "dd/MM/yyyy"), CLMS.Framework.DateTime.ToString($this?.EndDate, "dd/MM/yyyy"), ($this?.Informal ? "I" : "R"));
}

static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.Id == null || $this.Id == 0;
            }


}